import { ReactNode, useState, useEffect } from "react";
import ReactDOM from "react-dom";

export const Portal = ({ children }: { children: ReactNode }) => {
    const [container] = useState(() => document.createElement("div"));

    useEffect(() => {
        document.body.appendChild(container);
        return () => {
            document.body.removeChild(container);
        };
    }, [container]);

    return ReactDOM.createPortal(children, container);
};

export default Portal;
